<div id="step-enabling-container">
    <toro-enable-widget-group *ngFor="let g of widgetGroups"
        [widgetGroup]="g"
    ></toro-enable-widget-group>
</div>
